import {
  type ApplicationDetailsResponseDTO,
  ApplicationStatus,
} from '@/types/consumer-deposit-application-service';

export const defaultApplication = (): ApplicationDetailsResponseDTO => ({
  depositGuaranteeAccepted: false,
  status: ApplicationStatus.PROCESSING,
  termsConditionsAccepted: false,
});
